import React, { Component } from "react";
import {Modal} from 'react-bootstrap';
import ComplianceAuditorScreen from './ComplianceAuditorScreen'
export default class ModalForm  extends Component {
  render(){  
    let title = this.props.region.inventoryRegionName+' / '+this.props.center.inventoryCenterName+' / '+
    this.props.client.inventoryClientName+' / '+this.props.process.inventoryProcessName
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
      backdrop='static'            
      keyboard={false}
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Compliance Form For - {title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ComplianceAuditorScreen callTypeSelected={this.props.callTypeSelected} close={this.props.closeModal}
        function={this.props.function}  region={this.props.region} center={this.props.center}
         client={this.props.client} process={this.props.process}  loginUserName={this.props.loginUserName}
        auditorJson={this.props.template[0]} userData={this.props.complianceuserData}/> 
        </Modal.Body>
      </Modal>

    )
  }
}